"use client";

import { useEffect } from "react";
import { useMapEvents } from "react-leaflet";
import { Coordinates } from "../../types/MapData";
import { roundValue } from "../../MapUtil";

type Props = {
  centerChanged?: (val: Coordinates) => void;
  zoomChanged?: (val: number) => void;
};

export const MapPositionLogger = ({ centerChanged, zoomChanged }: Props) => {
  const map = useMapEvents({
    moveend: () => {
      if (!centerChanged) return;
      const center = map.getCenter();
      centerChanged({ x: roundValue(center.lng), y: roundValue(center.lat) });
    },
    zoomend: () => {
      if (!zoomChanged) return;
      const zoom = map.getZoom();
      zoomChanged(zoom);
    },
  });

  useEffect(() => {
    const center = map.getCenter();
    centerChanged?.({ x: roundValue(center.lng), y: roundValue(center.lat) });
  }, [map, centerChanged]);

  useEffect(() => {
    const zoom = map.getZoom();
    zoomChanged?.(zoom);
  }, [map, zoomChanged]);

  return null;
};
